<template>
  <div style="padding:20px;">
    <!-- 外层筛选与查询 -->
    <div style="margin-bottom:12px;">
      <el-select v-model="selectedProject" placeholder="选择项目" style="width:260px;">
        <el-option v-for="p in projectList" :key="p" :label="p" :value="p"></el-option>
      </el-select>
      <el-button type="primary" :loading="queryLoading" @click="doAnalyze">查询</el-button>

      <el-button type="success" @click="openManager" style="margin-left:10px;">项目管理</el-button>

      <el-button type="info" :disabled="!analyzeList.length" style="margin-left:10px;" @click="exportExcel">
        导出数据
      </el-button>
    </div>

    <!-- 加载提示 -->
    <div v-if="queryLoading" style="margin:15px 0; color:#409EFF;">正在查询中，请稍候...</div>

    <!-- 分析结果表 -->
    <el-table v-if="analyzeList.length" :data="analyzeList" border style="width:100%;">
      <el-table-column prop="project_name" label="项目名"></el-table-column>
      <el-table-column prop="client_name" label="客户名"></el-table-column>
      <el-table-column prop="spent" label="总消耗"></el-table-column>
      <el-table-column prop="formsubmitCount" label="总表单数"></el-table-column>
      <el-table-column prop="cpFormsubmit" label="总表单成本"></el-table-column>
      <el-table-column prop="backRegisterC" label="总注册数"></el-table-column>
      <el-table-column prop="cpBackRegisterC" label="总注册成本"></el-table-column>

      <el-table-column prop="current_spent" label="当前时段消耗"></el-table-column>
      <el-table-column prop="current_form_cost" label="当前时段表单成本"></el-table-column>
      <el-table-column prop="current_register_cost" label="当前时段注册成本"></el-table-column>

      <el-table-column prop="last_spent" label="上个时段消耗"></el-table-column>
      <el-table-column prop="last_form_cost" label="上个时段表单成本"></el-table-column>
      <el-table-column prop="last_register_cost" label="上个时段注册成本"></el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleProjectStop(scope.row)">
            拉停
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 拉停弹窗 -->
    <el-dialog title="拉停账户" :visible.sync="stopDialogVisible" width="1600px" :before-close="handleStopDialogClose"
      @opened="loadAccountList">
      <div v-if="currentStopProject">
        <!-- 项目信息 -->
        <el-alert type="info" :closable="false" style="margin-bottom: 20px;">
          <div style="line-height: 24px;">
            <strong>项目名称：</strong>{{ currentStopProject.project_name }} &nbsp;&nbsp;
            <strong>客户名称：</strong>{{ currentStopProject.client_name }} &nbsp;&nbsp;
            <strong>当前总消耗：</strong>{{ currentStopProject.spent }} &nbsp;&nbsp;
            <strong>密钥状态：</strong>
            <el-tag :type="currentStopProject.secret_key ? 'success' : 'danger'" size="small">
              {{ currentStopProject.secret_key ? '已配置' : '未配置' }}
            </el-tag>
          </div>
        </el-alert>

        <!-- 消费统计卡片 -->
        <div class="stats-cards" v-if="accountList.length > 0" style="margin-bottom: 20px;">
          <el-row :gutter="20">
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">今日消费累计</div>
                <div class="stat-value">{{ formatCurrency(totalStats.todayConsumeTotal) }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">昨日广告消费累计</div>
                <div class="stat-value">{{ formatCurrency(totalStats.yesterdayAdsTotal) }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">今日市场消费累计</div>
                <div class="stat-value">{{ formatCurrency(totalStats.todayMarketTotal) }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">现金余额累计</div>
                <div class="stat-value">{{ formatCurrency(totalStats.cashBalanceTotal) }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">累计消费总额</div>
                <div class="stat-value">{{ formatCurrency(totalStats.consumeAmountTotal) }}</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="stat-card">
                <div class="stat-label">有效创意总数</div>
                <div class="stat-value">{{ totalCreativeStats.activeCount }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 创意统计卡片 -->
        <!-- <div class="stats-cards" v-if="accountList.length > 0" style="margin-bottom: 20px;">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-card creative-card">
                <div class="stat-label">有效创意总数</div>
                <div class="stat-value creative-value">{{ totalCreativeStats.activeCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card creative-card">
                <div class="stat-label">审核中创意数</div>
                <div class="stat-value">{{ totalCreativeStats.auditingCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card creative-card">
                <div class="stat-label">审核不通过数</div>
                <div class="stat-value">{{ totalCreativeStats.auditNotPassCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card creative-card">
                <div class="stat-label">平均有效创意</div>
                <div class="stat-value">{{ totalCreativeStats.avgActiveCount }}</div>
              </div>
            </el-col>
          </el-row>
        </div> -->

        <!-- 账户列表加载状态 -->
        <div v-if="accountLoading" style="text-align: center; padding: 40px 0;">
          <el-icon class="is-loading" style="font-size: 24px; margin-right: 10px;">
            <!-- <Loading /> -->
          </el-icon>
          <span>正在加载账户列表...</span>
        </div>

        <!-- 账户列表表格 -->
        <div v-else>
          <!-- 操作工具栏 -->
          <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
            <div>
              <el-button type="primary" size="small" :disabled="selectedAccounts.length === 0" @click="selectAllAccounts">
                {{ selectedAccounts.length === accountList.length ? '取消全选' : '全选' }}
              </el-button>
              <span style="margin-left: 15px; color: #666;">
                已选中 {{ selectedAccounts.length }} 个账户
              </span>
            </div>
            <div>
              <el-input v-model="accountFilter" placeholder="搜索账户名/公司名" clearable
                style="width: 200px; margin-right: 10px;" size="small" />
              <el-button type="danger" size="small" :disabled="selectedAccounts.length === 0" @click="confirmBatchStop">
                批量拉停选中账户
              </el-button>
            </div>
          </div>

          <!-- 账户表格 -->
          <el-table :data="paginatedAccountList" border style="width:100%;"
            @selection-change="handleAccountSelectionChange" max-height="500" v-loading="accountLoading"
            ref="accountTable" @sort-change="handleAccountSortChange">
            <!-- 多选框列 -->
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>

            <el-table-column prop="name" label="账户名" width="150" show-overflow-tooltip fixed="left"></el-table-column>
            <el-table-column prop="companyName" label="公司名" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="id" label="账户ID" width="100"></el-table-column>
            <el-table-column prop="uuid" label="UUID" width="180" show-overflow-tooltip></el-table-column>

            <!-- 创意统计列 -->
            <el-table-column label="创意统计" width="300" align="center" sortable="custom" prop="creativeActiveCount">
              <template slot-scope="scope">
                <div class="creative-stats">
                  <el-tag type="success" size="mini" style="margin-right: 5px;">
                    有效: {{ scope.row.creativeActiveCount || 0 }}
                  </el-tag>
                  <el-tag type="warning" size="mini" style="margin-right: 5px;">
                    审核: {{ scope.row.creativeAuditingCount || 0 }}
                  </el-tag>
                  <el-tag type="danger" size="mini">
                    拒绝: {{ scope.row.creativeNotPassCount || 0 }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="todayConsumeAmount" label="今日消费" width="120" align="right" sortable="custom">
              <template slot-scope="scope">
                <span :class="{ 'highlight-red': parseFloat(scope.row.todayConsumeAmount) > 1000 }">
                  {{ formatCurrency(scope.row.todayConsumeAmount) }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="yesterdayAdsConsumeAmount" label="昨日广告消费" width="130" align="right" sortable="custom">
              <template slot-scope="scope">
                {{ formatCurrency(scope.row.yesterdayAdsConsumeAmount) }}
              </template>
            </el-table-column>
            <el-table-column prop="todayMarketConsumeAmount" label="今日市场消费" width="130" align="right">
              <template slot-scope="scope">
                <span :class="{ 'highlight-red': parseFloat(scope.row.todayMarketConsumeAmount) > 1000 }">
                  {{ formatCurrency(scope.row.todayMarketConsumeAmount) }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="cashBalance" label="现金余额" width="120" align="right">
              <template slot-scope="scope">
                {{ formatCurrency(scope.row.cashBalance) }}
              </template>
            </el-table-column>
            <el-table-column prop="consumeAmount" label="累计消费" width="120" align="right">
              <template slot-scope="scope">
                {{ formatCurrency(scope.row.consumeAmount) }}
              </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="80" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 2 ? 'success' : 'warning'" size="small">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="openTime" label="开户时间" width="150"></el-table-column>
            <el-table-column prop="belongSubRemark" label="所属渠道" width="150" show-overflow-tooltip></el-table-column>
          </el-table>

          <!-- 分页器 -->
          <div v-if="totalCount > 0" style="margin-top: 20px; text-align: right;">
            <el-pagination small layout="total, sizes, prev, pager, next, jumper" :total="totalCount"
              :page-size="pageSize" :current-page="currentPage" :page-sizes="[200]" @size-change="handlePageSizeChange"
              @current-change="handleCurrentPageChange" />
          </div>

          <!-- 无数据提示 -->
          <div v-if="accountList.length === 0 && !accountLoading"
            style="text-align: center; padding: 40px 0; color: #999;">
            <el-icon style="font-size: 48px; margin-bottom: 16px;">
              <!-- <Box /> -->
            </el-icon>
            <div>未找到符合条件的账户数据</div>
            <div style="margin-top: 10px; font-size: 14px;">
              请检查密钥是否正确或账户是否有消费数据
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelStop">取 消</el-button>
        <el-button type="danger" @click="confirmStop" :loading="stopLoading" :disabled="selectedAccounts.length === 0">
          {{ stopLoading ? '拉停中...' : `批量拉停选中账户 (${selectedAccounts.length})` }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 操作结果弹窗 -->
    <el-dialog title="拉停操作结果" :visible.sync="resultDialogVisible" width="1200px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div v-if="operationResult">
        <!-- 总体统计信息 -->
        <el-alert :type="operationResult.successCount > 0 ? 'success' : 'warning'" :closable="false"
          style="margin-bottom: 20px;">
          <div style="line-height: 24px;">
            <strong>总账户数：</strong>{{ operationResult.totalAccounts }} &nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>成功账户：</strong>
            <el-tag type="success" size="small">{{ operationResult.successCount }}</el-tag>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>失败账户：</strong>
            <el-tag type="danger" size="small">{{ operationResult.failedCount }}</el-tag>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>总广告组数：</strong>{{ operationResult.totalGroupsFound }} &nbsp;&nbsp;|&nbsp;&nbsp;

          </div>
          <div v-if="operationResult.successAccounts && operationResult.successAccounts.length > 0"
            style="margin-top: 8px;">
            <strong>成功账户：</strong>
            <el-tag v-for="account in operationResult.successAccounts" :key="account" type="success" size="small"
              style="margin-right: 5px; margin-bottom: 3px;">
              {{ account }}
            </el-tag>
          </div>
          <div v-if="operationResult.failedAccounts && operationResult.failedAccounts.length > 0"
            style="margin-top: 8px;">
            <strong>失败账户：</strong>
            <el-tag v-for="account in operationResult.failedAccounts" :key="account" type="danger" size="small"
              style="margin-right: 5px; margin-bottom: 3px;">
              {{ account }}
            </el-tag>
          </div>
        </el-alert>

        <!-- 账户操作结果表格 -->
        <div style="margin-bottom: 10px;">
          <h4 style="margin: 0 0 15px 0;">账户操作详情</h4>
        </div>
        <el-table :data="operationResult.accountResults" border style="width: 100%;" max-height="400"
          empty-text="暂无操作结果数据">
          <el-table-column prop="accountName" label="账户名" width="180" fixed="left">
            <template slot-scope="scope">
              <div>
                <strong>{{ scope.row.accountName }}</strong>
                <div style="font-size: 12px; color: #666; margin-top: 2px;">
                  {{ scope.row.area }}区 | 广告主ID: {{ scope.row.advertiserId }}
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 修改：使用 groupsCount 显示广告组总数 -->
          <el-table-column label="广告组数" width="100" align="center">
            <template slot-scope="scope">
              <el-tag type="primary" size="medium" style="font-size: 14px; font-weight: bold;">
                {{ scope.row.groupsCount || 0 }}
              </el-tag>
            </template>
          </el-table-column>



          <!-- 修改：使用 groupIds 显示广告组ID列表 -->
          <el-table-column label="广告组ID" min-width="300">
            <template slot-scope="scope">
              <div style="max-height: 100px; overflow-y: auto; padding: 5px 0;">
                <el-tag v-for="groupId in scope.row.groupIds" :key="groupId" type="info" size="mini"
                  style="margin-right: 3px; margin-bottom: 3px; font-size: 11px;">
                  {{ groupId }}
                </el-tag>
              </div>
              <div style="margin-top: 5px; font-size: 12px; color: #666;">
                共 {{ scope.row.groupIds ? scope.row.groupIds.length : 0 }} 个广告组
              </div>
            </template>
          </el-table-column>

          <!-- 修改：显示操作结果 -->
          <el-table-column label="操作结果" width="200">
            <template slot-scope="scope">
              <div>
                <el-tag :type="scope.row.success ? 'success' : 'danger'" size="small" style="margin-bottom: 5px;">
                  {{ scope.row.success ? '操作成功' : '操作失败' }}
                </el-tag>
                <div style="font-size: 12px; color: #666; line-height: 1.4;">
                  {{ scope.row.message }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 批量编辑详情 -->
        <div v-if="hasBatchEditResults" style="margin-top: 25px;">
          <h4 style="margin: 0 0 15px 0;">批量编辑详情</h4>
          <el-collapse v-model="activeCollapse">
            <el-collapse-item v-for="(account, index) in operationResult.accountResults" :key="index"
              :title="`账户：${account.accountName}（${account.batchEditDateResults.length}个批量操作）`" :name="index">
              <el-table :data="account.batchEditDateResults" border size="small" style="width: 100%;">
                <!-- 修改：去掉计划ID，保留组数和状态 -->
                <el-table-column prop="groupCount" label="广告组数" width="100" align="right"></el-table-column>
                <el-table-column prop="success" label="状态" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.success ? 'success' : 'danger'" size="small">
                      {{ scope.row.success ? '成功' : '失败' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="message" label="消息" min-width="200"></el-table-column>
                <el-table-column prop="retcode" label="返回码" width="80"></el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-dialog>

    <!-- 管理弹窗 -->
    <el-dialog title="项目管理" :visible.sync="managerVisible" width="80%" @open="loadPageData">
      <div style="margin-bottom:10px;">
        <el-button type="primary" @click="addRow">单个添加</el-button>
      </div>

      <el-table :data="tableData" border style="width:100%;">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="项目名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.project_name" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="客户名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.client_name" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="密钥">
          <template slot-scope="scope">
            <el-input v-model="scope.row.secret_key" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeRow(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="managerVisible = false">取消</el-button>
        <el-button type="primary" @click="saveManagerChanges">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  data: function () {
    return {
      // 分页相关
      currentPage: 1,        // 当前页码
      pageSize: 200,          // 每页条数
      paginatedList: [],
      accountSort: {
        prop: 'todayConsumeAmount',  // 当前排序字段
        order: 'desc'                 // 当前排序方式
      },
      userId: this.$route.query.userId,
      projectList: [],
      selectedProject: "",
      analyzeList: [],
      queryLoading: false,
      managerVisible: false,
      tableData: [],
      originalMap: {},
      changedSet: {},
      tempIndexCounter: 0,
      // 拉停相关数据
      selectedStopItems: [], // 选中的要拉停的项目
      stopDialogVisible: false, // 拉停弹窗显示状态
      currentStopProject: null, // 当前要拉停的项目
      stopLoading: false,
      // 账户列表相关
      accountList: [], // 账户列表数据
      selectedAccounts: [], // 选中的账户
      accountLoading: false, // 账户加载状态
      accountFilter: '', // 账户筛选条件
      accountPagination: {
        page: 1,
        size: 20,
        total: 0,
        pages: 0
      },
      // 操作结果弹窗相关
      resultDialogVisible: false,
      operationResult: null,
      activeCollapse: []
    };
  },
  computed: {
    totalStats() {
      const stats = {
        todayConsumeTotal: 0,
        yesterdayAdsTotal: 0,
        todayMarketTotal: 0,
        cashBalanceTotal: 0,
        consumeAmountTotal: 0
      };

      this.accountList.forEach(account => {
        stats.todayConsumeTotal += parseFloat(account.todayConsumeAmount) || 0;
        stats.yesterdayAdsTotal += parseFloat(account.yesterdayAdsConsumeAmount) || 0;
        stats.todayMarketTotal += parseFloat(account.todayMarketConsumeAmount) || 0;
        stats.cashBalanceTotal += parseFloat(account.cashBalance) || 0;
        stats.consumeAmountTotal += parseFloat(account.consumeAmount) || 0;
      });

      return stats;
    },

    // 创意统计汇总
    totalCreativeStats() {
      const stats = {
        activeCount: 0,
        avgActiveCount: 0
      };

      let accountWithCreativeCount = 0;
      this.accountList.forEach(account => {
        const activeCount = account.creativeActiveCount || 0;
        stats.activeCount += activeCount;
        if (activeCount > 0) accountWithCreativeCount++;
      });

      stats.avgActiveCount = accountWithCreativeCount > 0
        ? (stats.activeCount / accountWithCreativeCount).toFixed(1)
        : '0.0';

      return stats;
    },

    totalCount() {
      return this.sortedAccountList.length;
    },

    // 当前页显示的数据（前端分页）
    paginatedAccountList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedAccountList.slice(start, end);
    },

    // 过滤后的账户列表
    filteredAccountList() {
      if (!this.accountFilter) {
        return this.accountList;
      }
      const filter = this.accountFilter.toLowerCase();
      return this.accountList.filter(account =>
        (account.name && account.name.toLowerCase().includes(filter)) ||
        (account.companyName && account.companyName.toLowerCase().includes(filter)) ||
        (account.id && account.id.toString().includes(filter)) ||
        (account.uuid && account.uuid.toLowerCase().includes(filter))
      );
    },

    sortedAccountList() {
      const list = this.filteredAccountList;
      if (!list || list.length === 0) {
        return [];
      }

      const { prop, order } = this.accountSort;
      if (!prop || !order) {
        return list;
      }

      return [...list].sort((a, b) => {
        // 直接用 prop 字段的值排序
        let valA = a[prop];
        let valB = b[prop];

        // 如果是数字，转成数字比较
        if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
          valA = parseFloat(valA) || 0;
          valB = parseFloat(valB) || 0;
        }

        if (order === 'asc') {
          if (valA < valB) return -1;
          if (valA > valB) return 1;
          return 0;
        } else {
          if (valA > valB) return -1;
          if (valA < valB) return 1;
          return 0;
        }
      });
    },

    // 是否有批量编辑结果
    hasBatchEditResults() {
      return this.operationResult &&
        this.operationResult.accountResults &&
        this.operationResult.accountResults.some(account =>
          account.batchEditDateResults && account.batchEditDateResults.length > 0
        );
    }
  },
  created: function () {
    this.loadProjectList();
  },
  methods: {
    // 批量拉停账户
    // 批量拉停账户
    async batchStopAccounts() {
      if (this.selectedAccounts.length === 0) {
        this.$message.warning('请先选择要拉停的账户');
        return;
      }

      console.log('选中的账户:', this.selectedAccounts);

      // 准备账户名列表
      const accountNames = this.selectedAccounts.map(account => account.name);
      const ids = this.selectedAccounts.map(account => account.uuid);
      console.log('账户名列表:', accountNames);

      // 显示加载状态
      this.stopLoading = true;

      try {
        // 调用后端接口获取账户广告组
        const response = await axios.post('https://control.zjwec.cn/api/vivo/campaign/get-accounts', {
          accountNames: accountNames,
          ids: ids,
          secretkey: this.currentStopProject.secret_key
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        console.log('后端响应:', response.data);

        if (response.data.code == 0 && response.data.data) {
          const result = response.data.data;

          // 重新计算总切换成功数量
          let actualTotalEditDateSuccess = 0;

          // 格式化操作结果，显示每个账户拉停的广告组详情
          const formattedResult = {
            ...result,
            accountResults: result.accountResults.map(account => {
              // 构建每个账户的广告组详情
              const groupDetails = account.groupDetails || [];
              const groupIds = account.groupIds || [];

              // 从 batchEditDateResults 中获取实际的切换成功数量
              let actualEditDateSuccess = 0;
              if (account.batchEditDateResults && account.batchEditDateResults.length > 0) {
                const batchResult = account.batchEditDateResults[0];
                // 如果返回的 successCount 存在，使用它
                if (batchResult.successCount !== undefined) {
                  actualEditDateSuccess = batchResult.successCount;
                }
                // 如果操作成功但没有返回具体数量，默认所有广告组都成功
                else if (batchResult.success === true) {
                  actualEditDateSuccess = groupIds.length;
                }
              }

              // 累加到总数
              actualTotalEditDateSuccess += actualEditDateSuccess;

              return {
                ...account,
                // 使用实际的成功数量覆盖后端返回的 0
                editDateSuccessCount: actualEditDateSuccess,
                // 显示广告组数量
                groupsCount: groupIds.length,
                // 显示广告组ID列表
                groupIdList: groupIds,
                // 显示广告组详情
                groupInfo: groupDetails.map(g => ({
                  id: g.id,
                  name: g.name,
                  campaignName: g.campaignName,
                  status: g.status,
                  budget: g.budget
                })),
                // 操作消息
                message: account.message || (account.success ? `成功拉停 ${actualEditDateSuccess} 个广告组` : '拉停失败')
              };
            })
          };

          // 覆盖总切换成功数量
          formattedResult.totalEditDateSuccess = actualTotalEditDateSuccess;

          // 保存格式化后的操作结果
          this.operationResult = formattedResult;

          // 显示结果弹窗
          this.resultDialogVisible = true;

          // 显示成功消息 - 显示具体拉停的广告组数量
          if (result.successCount > 0) {
            const totalGroups = result.totalGroupsFound || 0;
            this.$message.success(
              `成功处理 ${result.successCount} 个账户，` +
              `共找到 ${totalGroups} 个广告组，` +
              `成功拉停 ${actualTotalEditDateSuccess} 个`
            );
          }

          if (result.failedCount > 0) {
            this.$message.warning(`${result.failedCount} 个账户处理失败`);
          }

          // 打印详细日志
          console.log('拉停结果详情:', {
            totalAccounts: result.totalAccounts,
            successAccounts: result.successAccounts,
            failedAccounts: result.failedAccounts,
            totalGroups: result.totalGroupsFound,
            successGroups: actualTotalEditDateSuccess,
            accountDetails: formattedResult.accountResults.map(a => ({
              account: a.accountName,
              groups: a.groupIds.length,
              successCount: a.editDateSuccessCount,
              success: a.success,
              message: a.message
            }))
          });

        } else {
          this.$message.error(response.data.msg || '获取广告组失败');
        }

      } catch (error) {
        console.error('获取广告组失败:', error);
        this.$message.error('获取账户广告组失败，请检查网络连接');
      } finally {
        this.stopLoading = false;
      }
    },

    // 加载账户列表
    async loadAccountList() {
      if (!this.currentStopProject || !this.currentStopProject.secret_key) {
        this.$message.warning('该项目未配置密钥，无法加载账户列表');
        this.accountList = [];
        return;
      }

      this.accountLoading = true;
      this.accountList = [];
      this.selectedAccounts = [];

      try {
        const params = new URLSearchParams();
        params.append('secret_key', this.currentStopProject.secret_key);
        params.append('timestamp', Date.now());

        const response = await axios.post(
          'https://control.zjwec.cn/api/vivo/latingaccount/list',
          params,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );

        if (response.data.retcode === 0 && response.data.data && response.data.data.list) {
          this.accountList = response.data.data.list.map(account => ({
            ...account,
            stopping: false,
            // 确保创意统计字段存在
            creativeActiveCount: account.creativeActiveCount || 0,
            creativeAuditingCount: account.creativeAuditingCount || 0,
            creativeNotPassCount: account.creativeNotPassCount || 0
          }));

          // 重置分页到第一页
          this.currentPage = 1;

          this.$message.success(`已加载 ${this.accountList.length} 个账户`);
        } else {
          this.$message.error(response.data.message || '加载账户列表失败');
        }
      } catch (error) {
        console.error('加载账户列表失败:', error);
        this.$message.error('加载账户列表失败，请检查网络或密钥是否正确');
      } finally {
        this.accountLoading = false;
      }
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置到第一页
    },

    // 页码变化
    handleCurrentPageChange(page) {
      this.currentPage = page;
    },

    // 修改 handleAccountSortChange 方法，排序后重置到第一页
    handleAccountSortChange({ prop, order }) {
      // 支持的排序字段
      const sortableFields = [
        'todayConsumeAmount',
        'yesterdayAdsConsumeAmount',
        'creativeActiveCount'  // 添加有效创意字段
      ];

      if (sortableFields.includes(prop)) {
        this.accountSort = {
          prop: prop,
          order: order === 'ascending' ? 'asc' : 'desc'
        };
        this.currentPage = 1; // 排序后重置到第一页
      }
    },

    // 账户选择变化
    handleAccountSelectionChange(selection) {
      this.selectedAccounts = selection;
    },

    // 全选/取消全选
    selectAllAccounts() {
      if (this.selectedAccounts.length === this.filteredAccountList.length) {
        this.$refs.accountTable.clearSelection();
      } else {
        this.filteredAccountList.forEach(row => {
          this.$refs.accountTable.toggleRowSelection(row);
        });
      }
    },

    // 确认批量拉停
    confirmBatchStop() {
      if (this.selectedAccounts.length === 0) {
        this.$message.warning('请先选择要拉停的账户');
        return;
      }

      const accountNames = this.selectedAccounts.map(acc => acc.name).join(', ');
      this.$confirm(
        `确定要批量拉停以下 ${this.selectedAccounts.length} 个账户吗？<br><strong>${accountNames}</strong>`,
        '确认批量拉停',
        {
          confirmButtonText: '确定拉停',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.batchStopAccounts();
      }).catch(() => {
        // 用户取消
      });
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.accountPagination.size = size;
      this.accountPagination.page = 1;
      this.loadAccountList();
    },

    // 页码改变
    handlePageChange(page) {
      this.accountPagination.page = page;
      this.loadAccountList();
    },

    // 格式化货币
    formatCurrency(value) {
      if (!value) return '0.00';
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '已停用',
        1: '待审核',
        2: '正常',
        3: '冻结',
        4: '异常'
      };
      return statusMap[status] || '未知';
    },

    // 账户拉停弹窗
    handleProjectStop(project) {
      console.log('拉停项目:', project);
      this.currentStopProject = project;
      this.stopDialogVisible = true;
    },

    // 关闭弹窗前确认
    handleStopDialogClose(done) {
      if (this.stopLoading) {
        return;
      }

      // 直接重置并关闭，不弹出确认框
      this.resetStopDialog();
      done();
    },

    // 重置拉停弹窗
    resetStopDialog() {
      this.stopDialogVisible = false;
      this.currentStopProject = null;
      this.accountList = [];
      this.selectedAccounts = [];
      this.accountFilter = '';
      this.stopLoading = false;
      this.accountLoading = false;
      this.accountPagination = {
        page: 1,
        size: 20,
        total: 0,
        pages: 0
      };
    },

    cancelStop() {
      this.resetStopDialog();
    },

    confirmStop() {
      this.confirmBatchStop();
    },

    // 加载项目名列表（带 userId）
    loadProjectList: function () {
      var that = this;
      axios.get("https://control.zjwec.cn/api/vivo/projectNames", { params: { userId: that.userId } })
        .then(function (resp) {
          if (resp.data && resp.data.data) that.projectList = resp.data.data;
        })
        .catch(function () { });
    },

    // 查询分析数据
    doAnalyze: function () {
      var that = this;
      if (!that.selectedProject) {
        that.$message.warning("请选择项目名");
        return;
      }
      that.queryLoading = true;
      that.analyzeList = [];
      axios.get("https://control.zjwec.cn/api/vivo/analyze", {
        params: { userId: that.userId, projectName: that.selectedProject }
      }).then(function (resp) {
        if (resp.data && resp.data.data) {

          axios.get("https://control.zjwec.cn/api/vivo/page", {
            params: { userId: that.userId, page: 1, size: 1000 }
          }).then((resp2) => {
            // 创建以 id 为键的映射
            const projectSecretMap = {};
            if (resp2.data && resp2.data.records) {
              resp2.data.records.forEach(record => {
                projectSecretMap[record.id] = record.secret_key; // 使用 id 作为键
              });
            }

            // 遍历 analyzeList，添加 secret_key
            const analyzeListWithSecret = resp.data.data.map(item => {
              // 使用 id 去映射中查找
              if (projectSecretMap[item.id]) { // 假设 analyze 返回的数据中也有 id 字段
                return {
                  ...item,
                  secret_key: projectSecretMap[item.id]
                };
              }
              return {
                ...item,
                secret_key: ''
              };
            });

            that.analyzeList = analyzeListWithSecret;
            console.log(that.analyzeList);
            that.queryLoading = false;

          }).catch((e) => {
            console.log(e);
            that.analyzeList = resp.data.data.map(item => ({
              ...item,
              secret_key: ''
            }));
            that.queryLoading = false;
          });

        } else {
          that.analyzeList = [];
          that.queryLoading = false;
        }
      }).catch(function () {
        that.queryLoading = false;
        that.$message.error("查询失败");
      });
    },

    // 导出分析数据为 Excel（中文表头）
    exportExcel: function () {
      var that = this;
      if (!that.analyzeList || !that.analyzeList.length) {
        that.$message.warning("没有可导出的数据");
        return;
      }

      try {
        // 定义字段与中文列名对应关系
        var headers = [
          { key: "project_name", label: "项目名" },
          { key: "client_name", label: "客户名" },
          { key: "spent", label: "总消耗" },
          { key: "formsubmitCount", label: "总表单数" },
          { key: "cpFormsubmit", label: "总表单成本" },
          { key: "backRegisterC", label: "总注册数" },
          { key: "cpBackRegisterC", label: "总注册成本" },
          { key: "current_spent", label: "当前时段消耗" },
          { key: "current_form_cost", label: "当前时段表单成本" },
          { key: "current_register_cost", label: "当前时段注册成本" },
          { key: "last_spent", label: "上个时段消耗" },
          { key: "last_form_cost", label: "上个时段表单成本" },
          { key: "last_register_cost", label: "上个时段注册成本" }
        ];

        // 生成数据表（数值字段转数字类型）
        var data = [];
        for (var i = 0; i < that.analyzeList.length; i++) {
          var item = that.analyzeList[i];
          var row = {};
          for (var j = 0; j < headers.length; j++) {
            var h = headers[j];
            var val = item[h.key];
            if (val === null || val === undefined || val === "") {
              row[h.label] = "";
            } else if (!isNaN(val) && val !== "") {
              // 转为数值类型（保持 0）
              row[h.label] = Number(val);
            } else {
              row[h.label] = val;
            }
          }
          data.push(row);
        }

        // 转成 Sheet
        var ws = XLSX.utils.json_to_sheet(data);

        // 设置列样式（数字列右对齐、保留2位小数）
        var range = XLSX.utils.decode_range(ws["!ref"]);
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var header = ws[XLSX.utils.encode_cell({ r: 0, c: C })].v;
          // 检测是否数字列
          if (
            /消耗|成本|数$/.test(header)
          ) {
            for (var R = 1; R <= range.e.r; ++R) {
              var cellAddr = XLSX.utils.encode_cell({ r: R, c: C });
              var cell = ws[cellAddr];
              if (cell && typeof cell.v === "number") {
                cell.t = "n"; // 指定为数值类型
                cell.z = "0.00"; // 显示两位小数
              }
            }
          }
        }

        // 新建工作簿
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "分析数据");

        // 文件名
        var now = new Date();
        var fileName =
          "分析数据_" +
          now.getFullYear() +
          "-" +
          (now.getMonth() + 1) +
          "-" +
          now.getDate() +
          "_" +
          now.getHours() +
          "-" +
          now.getMinutes() +
          ".xlsx";

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          fileName
        );

        that.$message.success("导出成功");
      } catch (e) {
        that.$message.error("导出失败");
        console.error(e);
      }
    },

    // 打开管理弹窗
    openManager: function () {
      this.managerVisible = true;
      this.loadPageData();
    },

    // 加载项目分页数据
    loadPageData: function () {
      var that = this;
      axios.get("https://control.zjwec.cn/api/vivo/page", { params: { userId: that.userId, page: 1, size: 1000 } })
        .then(function (resp) {
          var records = [];
          if (resp.data && resp.data.data && resp.data.data.records) {
            records = resp.data.data.records;
          } else if (resp.data && resp.data.records) {
            records = resp.data.records;
          } else {
            records = resp.data;
          }
          that.tableData = records || [];
          that.originalMap = {};
          that.changedSet = {};
          for (var i = 0; i < that.tableData.length; i++) {
            var item = that.tableData[i];
            if (item.id) {
              that.originalMap[String(item.id)] = JSON.stringify(item);
            } else {
              var key = "_tmp_" + (++that.tempIndexCounter);
              item._tempKey = key;
              that.originalMap[key] = JSON.stringify(item);
            }
          }
        }).catch(function () {
          that.$message.error("加载失败");
        });
    },

    // 标记修改
    markChanged: function (row) {
      var key = row.id ? String(row.id) : row._tempKey;
      this.changedSet[key] = true;
    },

    // 新增行
    addRow: function () {
      var key = "_tmp_" + (++this.tempIndexCounter);
      var r = { id: null, project_name: "", client_name: "", secret_key: "", user_id: this.userId, _tempKey: key };
      this.tableData.unshift(r);
      this.originalMap[key] = JSON.stringify(r);
      this.changedSet[key] = true;
    },

    // 删除行
    removeRow: function (index, row) {
      var that = this;
      if (row.id) {
        axios.delete("https://control.zjwec.cn/api/vivo/delete/" + row.id)
          .then(function () {
            that.$message.success("删除成功");
            that.loadPageData();
            that.loadProjectList();
          })
          .catch(function () {
            that.$message.error("删除失败");
          });
      } else {
        that.tableData.splice(index, 1);
        if (row._tempKey) {
          delete that.originalMap[row._tempKey];
          delete that.changedSet[row._tempKey];
        }
      }
    },

    // 保存修改
    saveManagerChanges: function () {
      var that = this;
      var toSubmit = [];
      for (var i = 0; i < that.tableData.length; i++) {
        var item = that.tableData[i];
        var key = item.id ? String(item.id) : item._tempKey;
        var orig = that.originalMap[key];
        var curr = JSON.stringify(item);
        if (that.changedSet[key] || !orig || orig !== curr) {
          var copy = {};
          for (var k in item) {
            if (k === "_tempKey") continue;
            copy[k] = item[k];
          }
          toSubmit.push(copy);
        }
      }

      if (toSubmit.length === 0) {
        that.$message.info("没有变动，无需保存");
        return;
      }

      axios.post("https://control.zjwec.cn/api/vivo/saveOrUpdate", toSubmit)
        .then(function () {
          that.$message.success("保存成功");
          that.loadPageData();
          that.loadProjectList();
        })
        .catch(function () {
          that.$message.error("保存失败");
        });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

/* 高亮今日消费较高的账户 */
.highlight-red {
  color: #f56c6c;
  font-weight: bold;
}

/* 表格行悬停效果 */
.el-table :deep(.hover-row) {
  background-color: #f5f7fa !important;
}

/* 表格头样式 */
.el-table :deep(.el-table__header-wrapper) th {
  background-color: #f0f2f5;
  font-weight: 600;
  color: #303133;
}

/* 结果弹窗样式 */
:deep(.el-alert) {
  margin-bottom: 15px;
}

:deep(.el-collapse) {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

:deep(.el-collapse-item__header) {
  font-weight: 600;
  background-color: #f8f9fa;
}

.stats-cards {
  margin-bottom: 20px;
}

.stat-card {
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  padding: 12px 8px;
  color: #3173b3;
  text-align: center;
  transition: all 0.3s;
}

.stat-card:hover {
  background-color: #d9ecff;
  border-color: #b3d8ff;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 5px;
  white-space: nowrap;
  color: #5e6b82;
}

.stat-value {
  font-size: 16px;
  font-weight: bold;
  font-family: 'Courier New', monospace;
  color: #3173b3;
}

/* 创意卡片特殊样式 */
.creative-card {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

.creative-card .stat-label {
  color: #67c23a;
}

.creative-card .stat-value {
  color: #67c23a;
}

.creative-card .creative-value {
  font-size: 20px;
  color: #e6a23c;
}

/* 创意统计列样式 */
.creative-stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3px;
}

.creative-stats .el-tag {
  margin: 2px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .creative-stats {
    flex-direction: column;
    align-items: center;
  }

  .creative-stats .el-tag {
    margin: 2px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/vivo/vivoYYZHQuery.vue